var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 30,
    viewBox: "0 0 20 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_17725",
    "data-name": "Group 17725",
    transform: "translate(-450 -146)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_502",
    "data-name": "Group 502",
    transform: "translate(-3 -76)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_38",
    "data-name": "Rectangle 38",
    width: 30,
    height: 30,
    transform: "translate(453 222)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_501",
    "data-name": "Group 501",
    transform: "translate(-2.5 3)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_240",
    "data-name": "Line 240",
    x2: 12,
    transform: "translate(464.5 230)",
    fill: "none",
    stroke: "#07273f",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_241",
    "data-name": "Line 241",
    x2: 9.333,
    transform: "translate(467.167 233.667)",
    fill: "none",
    stroke: "#07273f",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_242",
    "data-name": "Line 242",
    x2: 6.667,
    transform: "translate(469.833 237.333)",
    fill: "none",
    stroke: "#07273f",
    strokeWidth: 1.2
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/Filter.3b9485265ceb35a70b413c4b13c70939.svg";
export { ForwardRef as ReactComponent };